export default "__VITE_ASSET__DGYrVk2Z__"